import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webSiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '欧美一区二区·高清内容聚合平台',
    url: 'https://oumei-yiqierqu.com/',
    description: '专业欧美影视内容分区导航平台，精准划分欧美一区二区资源，提供高清流畅的分区浏览体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://oumei-yiqierqu.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webSiteLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}